import { useState } from "react";
import { rtctApi } from "services/rtctApi";

// The debug profiler (dbg_phaseA_ina) on Node control, for staff: whether the node's newest readings show it running
// (settings' profiler; the node's read-back does not report the setting) and a switch. While it is on, the battery
// sensor is sampled through every wake and the 5 V rail stays up through uploads, so every upload costs more.
const PENDING = ["queued", "sent", "acknowledged"];

export function profilerState(settings) {
  const seen = settings?.profiler;
  const on = seen === true ? true : seen === false ? false : null;
  const desired = settings?.desired && typeof settings.desired === "object" ? settings.desired.dbg_phaseA_ina : undefined;
  const asked = desired === 0 || desired === 1 ? desired : null;
  const pending = asked !== null && PENDING.includes(settings?.status) && on !== (asked === 1);
  return { on, asked, pending };
}

export default function DebugProfilerCard({ mac, settings, onSent, confirm = (text) => window.confirm(text) }) {
  const [busy, setBusy] = useState(false);
  const [note, setNote] = useState("");
  if (!Array.isArray(settings?.allowed_keys) || !settings.allowed_keys.includes("dbg_phaseA_ina")) return null;
  const s = profilerState(settings);
  const send = async (value) => {
    if (value === 1 && !confirm("Turn the debug profiler on? Every upload costs more until it is turned off again.")) return;
    setBusy(true);
    setNote("");
    try {
      await rtctApi.applySettings(mac, { dbg_phaseA_ina: value });
      setNote("Sent. The node takes it at its next upload, and its readings show the change after that.");
      onSent?.();
    } catch (e) {
      setNote(e?.message || "Not sent");
    } finally {
      setBusy(false);
    }
  };
  return (
    <section className="field-panel" aria-label="Debug profiler">
      <div className="field-panel-head">
        <div>
          <h2>Debug profiler</h2>
          <p>Staff only</p>
        </div>
        <span className="field-state">{s.on === null ? "No readings yet" : s.on ? "On" : "Off"}</span>
      </div>
      <div className="field-panel-body">
        <p className="field-caption">
          While it is on, the battery sensor is sampled through every wake and the 5 V rail stays up through uploads, so
          every upload costs more. Read from the newest readings: the node does not report the setting itself.
        </p>
        {s.pending && (
          <div className="field-notice">Requested {s.asked === 1 ? "on" : "off"}, waiting for the node's readings to show it.</div>
        )}
        {s.on !== null && (
          <div className="field-actions">
            <button type="button" className="field-button" disabled={busy} onClick={() => send(s.on ? 0 : 1)}>
              {s.on ? "Turn off" : "Turn on"}
            </button>
          </div>
        )}
        {note && (
          <p className="field-caption" role="status">
            {note}
          </p>
        )}
      </div>
    </section>
  );
}
